export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6688.815cf652.jpg";